<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblAddDealer</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
          </a>
        </div>
      </div>
      <form [formGroup]="addDealerForm" (ngSubmit)="onSubmit()">
        <div class="card-accord scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="cst-acc-card mb20">
                <div class="row">
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="name"><span translate>lblDealerName</span><span class="text-danger"> * </span>
                    </label>
                    <div class="lbl-info">
                      <input formControlName="name" class="form-control mb-2" maxlength="30"
                        [ngClass]="{'is-invalid': (cpf.name.touched || cpf.name.dirty) && cpf.name.errors}"
                        placeholder="{{ 'lblEnterDealerName' | translate }}">
                      <div *ngIf="(cpf.name.touched || cpf.name.dirty) && cpf.name.errors">
                        <div *ngIf="cpf.name.errors.required" class="help-block mt-1 text-danger" translate>
                          lblDealerNameRequired
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="service" translate>lblCompanyNumber
                      <strong class="mlt6 required" *ngIf="!isMg"> * </strong>
                    </label>
                    <div class='lbl-info'>
                      <input type="text" formControlName="companyNumber" class="form-control"
                        placeholder="{{ 'lblEnterCompanyNumber' | translate }}" [required]="!isMg" maxlength="30"
                        [ngClass]="{'is-invalid': cpf.companyNumber.invalid && cpf.companyNumber.touched}">
                      <div *ngIf="cpf.companyNumber.invalid && (cpf.companyNumber.dirty || cpf.companyNumber.touched)"
                        class="help-block text-danger">
                        <div *ngIf="cpf.companyNumber.errors.required" class="help-block mt-1 text-danger" translate>
                          lblCompanyNumberRequired
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="isShowLocationCode">
                    <label for="DealershipsId"><span translate>lblDealershipsId</span> <span class="text-danger"> *
                      </span>
                    </label>
                    <div class="lbl-info">
                      <ng-select formControlName="dealershipsId" placeholder="{{ 'lblEnterDealershipsId' | translate }}"
                        required
                        [ngClass]="{'is-invalid': (cpf.dealershipsId.touched || cpf.dealershipsId.dirty) && cpf.dealershipsId.errors}">
                        <ng-template ng-header-tmp>
                          <span class="mbold w-66px">Code</span>
                          <span class="mbold" translate>lblDealershipsId</span>
                        </ng-template>
                        <ng-option *ngFor="let item of locationDropdown" [value]="item.rowId">
                          <span class="w-66px">{{item.code}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{item.name}}</span>
                        </ng-option>
                      </ng-select>
                      <div *ngIf="(cpf.dealershipsId.touched || cpf.dealershipsId.dirty) && cpf.dealershipsId.errors">
                        <div *ngIf="cpf.dealershipsId.errors.required" class="help-block mt-1 text-danger"><span
                            translate>lblDealershipsIdRequired</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="FranchiseId"><span translate>lblFranchiseId</span>
                    </label>
                    <div class="lbl-info">
                      <input formControlName="franchiseId" maxlength="15" id="FranchiseId" (keypress)="isDigit($event)"
                        class="form-control mb-2" placeholder="{{ 'lblEnterFranchiseId' | translate }}">
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="vatNumber"><span translate>lblVATNumber</span><span class="text-danger" *ngIf="!isMg"> * </span>
                    </label>
                    <div class="lbl-info">
                      <input formControlName="vatNumber" maxlength="20" id="vatNumber"
                        [ngClass]="{'is-invalid': (cpf.vatNumber.touched || cpf.vatNumber.dirty) && cpf.vatNumber.errors}"
                        class="form-control mb-2" placeholder="{{ 'lblEnterVATNumber' | translate }}">
                      <div *ngIf="(cpf.vatNumber.touched || cpf.vatNumber.dirty) && cpf.vatNumber.errors">
                        <div *ngIf="cpf.vatNumber.errors.required" class="help-block mt-1 text-danger" translate>
                          lblVATNumberRequired
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="false" class="col-lg-6 col-xl-3 af-form-group">
                    <label for="bankAccountNumber"><span translate>lblBankAccountNumber</span>
                    </label>
                    <div class="lbl-info">
                      <input formControlName="bankAccountNumber" id="bankAccountNumber" class="form-control mb-2"
                        [ngClass]="{'is-invalid': (cpf.bankAccountNumber.touched || cpf.bankAccountNumber.dirty) && cpf.bankAccountNumber.errors}"
                        placeholder="{{ 'lblEnterBankAccountNumber' | translate }}" maxlength="30">
                      <div
                        *ngIf="(cpf.bankAccountNumber.touched || cpf.bankAccountNumber.dirty) && cpf.bankAccountNumber.errors"
                        class="help-block mt-1 text-danger" translate>
                        lblInvallidBankAccountNumber
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="service" translate>lblCustomerWaitingLimit
                      <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class='lbl-info'>
                      <input type="text" formControlName="customerWaitingLimit" class="form-control"
                        placeholder="{{ 'lblEnterNumber' | translate }}" pattern="^[0-9]*$" required maxlength="4"
                        [ngClass]="{'is-invalid': cpf.customerWaitingLimit.invalid && cpf.customerWaitingLimit.touched}">
                      <div
                        *ngIf="cpf.customerWaitingLimit.invalid && (cpf.customerWaitingLimit.dirty || cpf.customerWaitingLimit.touched)"
                        class="help-block text-danger">
                        <div *ngIf="cpf.customerWaitingLimit.errors.required"><span
                            translate>lblCustomerWaitingLimitRequired</span></div>
                        <div *ngIf="cpf.customerWaitingLimit.errors.pattern"><span
                            translate>lblOnlyNumbersAreAllowed</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="cst-acc-card mb20">
                <div class="row">
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="address1"><span translate>lblAddressLine1</span><span class="text-danger"> * </span>
                    </label>
                    <div class="lbl-info">
                      <input formControlName="address1" maxlength="150"
                        [ngClass]="{'is-invalid': (cpf.address1.touched || cpf.address1.dirty) && cpf.address1.errors}"
                        class="form-control mb-2" placeholder="{{ 'lblEnterAddressLine 1' | translate }}">
                      <div *ngIf="(cpf.address1.touched || cpf.address1.dirty) && cpf.address1.errors">
                        <div *ngIf="cpf.address1.errors.required" class="help-block mt-1 text-danger" translate>
                          lblAddressLine1Required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="address2" translate>lblAddressLine2</label>
                    <div class="lbl-info">
                      <input formControlName="address2" class="form-control mb-2"
                        placeholder="{{ 'lblEnterAddressLine 2' | translate }}" maxlength="150">
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="pincode"><span translate>lblPostCode</span> <span class="text-danger"> * </span>
                    </label>
                    <div class='lbl-info'>
                      <ng-select formControlName="pincode" placeholder="{{ 'lblSelectPostCode' | translate }}" required
                        [virtualScroll]="true" (change)="onPostCodeSelected($event)"
                        [ngClass]="{'ng-select-is-invalid':(cpf.pincode.invalid  && cpf.pincode.touched) || (cpf.pincode.invalid  && isFormValid)}">
                        <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                          {{item.code}}</ng-option>
                      </ng-select>
                      <div
                        *ngIf="(cpf.pincode.invalid && (cpf.pincode.dirty || cpf.pincode.touched)) || (cpf.pincode.invalid && isFormValid)"
                        class="help-block text-danger">
                        <div *ngIf="cpf.pincode.errors.required"><span translate>lblRequiredPostCode</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="city"><span translate>lblCity</span><span class="text-danger"> * </span>
                    </label>
                    <div class='lbl-info'>
                      <ng-select formControlName="city" placeholder="{{ 'lblSelectCity' | translate }}" required
                        (change)="onCitySelected($event)"
                        [ngClass]="{'ng-select-is-invalid':(cpf.city.invalid  && cpf.city.touched) || (cpf.city.invalid  && isFormValid)}">
                        <ng-option *ngFor="let item of cityList" [value]="item">
                          {{item}}</ng-option>
                      </ng-select>
                      <div
                        *ngIf="(cpf.city.invalid && (cpf.city.dirty || cpf.city.touched)) || (cpf.city.invalid && isFormValid)"
                        class="help-block text-danger">
                        <div *ngIf="cpf.city.errors.required"><span translate>lblRequiredCity</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="country"><span translate>lblCountry</span><span class="text-danger"> * </span>
                    </label>
                    <div class="lbl-info">
                      <select formControlName="country"
                        [ngClass]="{'is-invalid': (cpf.country.touched || cpf.country.dirty) && cpf.country.errors}"
                        class="custom-select custom-select mb-2">
                        <option disabled value="-1" translate>lblSelectCountry</option>
                        <option *ngFor="let country of countryList" [ngValue]="country.id">
                          {{country.countryName}}</option>
                      </select>
                      <div *ngIf="(cpf.country.touched || cpf.country.dirty) && cpf.country.errors">
                        <div *ngIf="cpf.country.errors.required || cpf.country.errors.min"
                          class="help-block mt-1 text-danger" translate>
                          lblCountryRequired
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="landline"><span translate>lblLandline</span><span class="text-danger"> * </span>
                    </label>
                    <div class="lbl-info">
                      <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="landline" [cssClass]="{'form-control': true}"
                      [selectedCountryISO]="selectedCountryISOLandline" [maxLength]="15" [phoneValidation]="false"
                      [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                      [customPlaceholder]="'lblEnterLandline' | translate" (keyup)="onLandlineChange()"
                      (countryChange)="onCountryChangeForLandline($event)"
                      ></ngx-intl-tel-input>
                      <div *ngIf="(cpf.landline.touched || cpf.landline.dirty) && cpf.landline.errors">
                        <div *ngIf="cpf.landline.errors.required" class="help-block mt-1 text-danger" translate>
                          lblLandlineRequired
                        </div>
                        <div *ngIf="cpf.landline.errors.pattern" class="help-block mt-1 text-danger" translate>
                          lblEnterValidLandline
                        </div>
                      </div>

                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="mobile"><span translate>lblMobile</span>
                    </label>
                    <div class="lbl-info">
                      <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="mobile" [cssClass]="{'form-control': true}"
                      [selectedCountryISO]="selectedCountryISOMobile" [maxLength]="15" [phoneValidation]="false"
                      [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="true"
                      [customPlaceholder]="'lblEnterMobile' | translate" (keyup)="onMobileChange()"
                      (countryChange)="onCountryChange($event)"
                      ></ngx-intl-tel-input>
                      <div *ngIf="(cpf.mobile.touched || cpf.mobile.dirty) && cpf.mobile.errors">
                        <div *ngIf="cpf.mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                          lblEnterValidMobile
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="email"><span translate>lblEmail</span><span class="text-danger"> * </span>
                    </label>
                    <div class="lbl-info">
                      <input formControlName="email" maxlength="50"
                        [ngClass]="{'is-invalid': (cpf.email.touched || cpf.email.dirty) && cpf.email.errors}"
                        class="form-control mb-2" placeholder="{{ 'lblEnterEmail' | translate }}">
                      <div *ngIf="(cpf.email.touched || cpf.email.dirty) && cpf.email.errors">
                        <div *ngIf="cpf.email.errors.required" class="help-block mt-1 text-danger" translate>
                          lblEmailRequired
                        </div>
                        <div *ngIf="cpf.email.errors.pattern" class="help-block mt-1 text-danger" translate>
                          lblEnterValidEmail
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="cst-acc-card mb20" *ngIf="!isShowPriceInBrand">
                <div class="row">
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="service" translate>lblLabourHourlyRate
                      <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class='lbl-info'>
                      <input type="text" formControlName="unitPrice" class="form-control"
                        placeholder="{{ 'lblEnterLabourHourlyRate' | translate }}" pattern="^[\d,.\s]+$" required
                        maxlength="10" (change)="onChangeUnitPrice($event)" (keyup)="checkLength($event)"
                        [ngClass]="{'is-invalid': cpf.unitPrice.invalid && cpf.unitPrice.touched}">

                      <div *ngIf="cpf.unitPrice.invalid && (cpf.unitPrice.dirty || cpf.unitPrice.touched)"
                        class="help-block text-danger">
                        <div *ngIf="cpf.unitPrice.errors.required"><span translate>lblRateRequired</span></div>
                        <div *ngIf="cpf.unitPrice.errors.pattern || isValidUnitPrice">
                          <span translate>lblProperValue</span>
                        </div>
                      </div>
                      <div *ngIf="isUnitPriceLengthError" class="help-block mt-1 text-danger" translate> <em
                          class="ft-alert-circle align-middle" aria-hidden="true"></em>
                        lblRateUpto6digit
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row">
                <div class='col-lg-6 col-xl-3 af-form-group'>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                    <label class="custom-control-label" for="isActive" translate>lblActive</label>
                  </div>
                </div>
                <div class='col-lg-6 col-xl-3 af-form-group'>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="isActiveForWidget"
                      formControlName="isActiveForWidget">
                    <label class="custom-control-label" for="isActiveForWidget" translate>lblOnlineBookingWidget</label>
                  </div>
                </div>

                <div class='col-lg-6 col-xl-3 af-form-group'>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="onlinePayment"
                      formControlName="onlinePayment">
                    <label class="custom-control-label" for="onlinePayment" translate>lblonlinePayment</label>
                  </div>
                </div>

                <div class='col-lg-6 col-xl-3 af-form-group  mt-lg-3 mt-xl-0' *ngIf="isPickUpDropOff">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="vehiclePickupDropoffService"
                      formControlName="vehiclePickupDropoffService">
                    <label class="custom-control-label" for="vehiclePickupDropoffService"
                      translate>lblVehiclePickupAndDropoffService</label>
                  </div>
                </div>

                <div class='col-lg-6 col-xl-3 af-form-group'  *ngIf="isShareBoxEnabled && !isMg">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="keyLocation" formControlName="keyLocation"
                      (change)="showHideDealerSession()">
                    <label class="custom-control-label" for="keyLocation" translate>lblSharebox</label>
                    </div>
                </div>

                <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="showDealerSession && !isMg">
                  <label for="dealeSessionId"><span translate>lblShareBoxSessionId <span
                        class="text-danger">*</span></span>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="dealerSessionId" id="dealerSessionId" class="form-control mb-2"
                      [ngClass]="{'is-invalid': (cpf.dealerSessionId.touched || cpf.dealerSessionId.dirty) && cpf.dealerSessionId.errors}"
                      placeholder="{{ 'lblEnterShareBoxSessionId' | translate }}"
                      (keyup)="validateDealerSessionId()">
                    <div
                      *ngIf="((cpf.dealerSessionId.touched || cpf.dealerSessionId.dirty) && cpf.dealerSessionId.errors) || isDealerSessionIdError"
                      class="help-block mt-1 text-danger" translate>
                      lblInvallidDealerSessionId
                    </div>
                  </div>

                </div>
                <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="showDealerSession && !isMg">
                  <label for="dealerDropInLink"><span translate>lblShareBoxDropInLink <span
                        class="text-danger">*</span></span>
                  </label>
                  <div class="lbl-info">
                    <input formControlName="dealerDropInLink" id="dealerDropInLink" class="form-control mb-2"
                      [ngClass]="{'is-invalid': (cpf.dealerDropInLink.touched || cpf.dealerDropInLink.dirty) && cpf.dealerDropInLink.errors}"
                      placeholder="{{ 'lblEnterShareBoxSessionId' | translate }}"
                      (keyup)="validateDealerSessionId()">
                    <div
                      *ngIf="((cpf.dealerDropInLink.touched || cpf.dealerDropInLink.dirty) && cpf.dealerDropInLink.errors) || isDealerSessionIdError"
                      class="help-block mt-1 text-danger" translate>
                      lblInvallidDealerSessionId
                    </div>
                  </div>

                </div>
              </div>
              <div class="cst-acc-card mb20 form-row" *ngIf="isMg">
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="kiosk"
                      formControlName="kiosk">
                    <label class="custom-control-label" for="kiosk"
                      translate>lblOlbKiosk</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="enableMenuPricing"
                      formControlName="enableMenuPricing">
                    <label class="custom-control-label" for="enableMenuPricing"
                      translate>lblOlbEnableMenuPricing</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="enableBookingNotification"
                      formControlName="enableBookingNotification">
                    <label class="custom-control-label" for="enableBookingNotification"
                      translate>lblOlbEnableBookingNotification</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3">
                  <label for="leadTime"><span translate>lblOlbLeadTime</span>
                  </label>
                  <div class="lbl-info">
                    <input type="number" class="form-control mb-2" id="leadTime" formControlName="leadTime">
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="enableDMS"
                      formControlName="enableDMS">
                    <label class="custom-control-label" for="enableDMS"
                      translate>lblOlbEnableDMS</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="serviceAgreement"
                      formControlName="serviceAgreement">
                    <label class="custom-control-label" for="serviceAgreement"
                      translate>lblOlbServiceAgreement</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="realTimeBooking"
                      formControlName="realTimeBooking">
                    <label class="custom-control-label" for="realTimeBooking"
                      translate>lblOlbRealTimeBooking</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3">
                  <label for="noOfWeekInCalendar"><span translate>lblOlbNoOfWeekInCalendar</span>
                  </label>
                  <div class="lbl-info">
                    <input type="number" class="form-control mb-2" id="noOfWeekInCalendar" formControlName="noOfWeekInCalendar">
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group mt-3 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="isCampaignPriceConsidered"
                      formControlName="isCampaignPriceConsidered">
                    <label class="custom-control-label" for="isCampaignPriceConsidered"
                      translate>lblIsCampaignPriceConsidered</label>
                  </div>
                </div>
              </div>
              <div class="cst-acc-card mb20 form-row" *ngIf="isMg">
                <div class="col-lg-6 col-xl-3 af-form-group py-4 d-flex align-items-center">
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="enableRentalCar"
                      formControlName="enableRentalCar">
                    <label class="custom-control-label" for="enableRentalCar"
                      translate>lblOlbEnableRentalCar</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group d-flex align-items-center" *ngIf="cpf.enableRentalCar.value">
                  <div class="col-auto d-flex flex-row">
                    <input type="radio" class="radio-custom" id="rentalProvider1" formControlName="rentalProvider" [value]="1">
                    <label class="form-check-label" for="rentalProvider1" translate>lblOlbOwnRentalCar</label>
                  </div>
                  <div class="col-auto d-flex flex-row">
                    <input type="radio" class="radio-custom" id="rentalProvider2" formControlName="rentalProvider" [value]="2">
                    <label class="form-check-label" for="rentalProvider2" translate>lblOlbThirdPartyRentalCar</label>
                  </div>
                </div>
                <div class="col-lg-6 col-xl-3 af-form-group" *ngIf="cpf.enableRentalCar.value && cpf.rentalProvider.value == 2">
                  <label for="rentalCarPrice"><span translate>lblOlbThirdPartyRentalCarPrice</span>
                  </label>
                  <div class="lbl-info">
                    <input type="number" class="form-control mb-2" id="rentalCarPrice" formControlName="rentalCarPrice">
                  </div>
                </div>
              </div>
              <div class="row pl-3" *ngIf="isMg">
                <div class="col-12 af-form-group">
                  <div class="row">
                    <div class="col-12 col-md-3">
                      <div class="af-form-group">
                        <label translate>lblTimeDeliveryOfCar</label>
                        <div class="lbl-info">
                            <div class="d-flex align-items-center">
                                <div class="date">
                                  <ngb-timepicker [(ngModel)]="deliveryTimeSlot"
                                  [ngModelOptions]="{standalone: true}"></ngb-timepicker>
                                </div>
                                <button type="button" class="btn btn-primary ml-2" ngbTooltip="{{'lblAdd' | translate}}" container="body" tooltipClass="custom-revert" (click)="onTimeSlotAdd()">
                                  <em class="fa fa-plus"></em>
                              </button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <div class="col-12 col-md-9 d-flex align-items-center">
                      <div class="d-flex flex-wrap">
                        <div *ngFor="let slot of configurationArrivalTimes">
                          <div class="time-slot d-flex justify-content-center align-items-center">
                            <span> {{slot.timeSlot}} </span>
                            <em class="far fa-trash-alt fa-lg" ngbTooltip="{{'lblDelete' | translate}}" container="body" tooltipClass="custom-revert" (click)="onTimeSlotDelete(slot.timeSlot)"></em>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button class="btn btn-primary mr-sm-2 btn-lg"
                [disabled]="(addDealerForm.invalid || isUnitPriceLengthError) || isDealerSessionIdError"
                aria-label="Center Align" translate> <em class="fa fa-plus font16 align-top mr-2"></em>
                lblAdd</button>
              <a (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em
                  class="far fa-times-circle font16 align-top mr-2"></em> lblCancel</a>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>